import type { TaxBracket, TaxRebate, TaxThresholds, TaxYear } from '../../../types/tax';
import { BaseTaxYearStrategy } from '../TaxYearStrategy';
import {
  TAX_BRACKETS_2023_24,
  TAX_REBATES_2023_24,
  TAX_THRESHOLDS_2023_24,
  ANNUAL_MEDICAL_AID_CREDITS_2023_24
} from '../../../data/tax';

export class TaxYear2023_24Strategy extends BaseTaxYearStrategy {
  getYear(): TaxYear {
    return '2023-24';
  }
  
  getDisplayName(): string {
    return '2023-2024 Tax Year';
  }
  
  getTaxBrackets(): TaxBracket[] {
    return TAX_BRACKETS_2023_24;
  }
  
  getTaxRebates(): TaxRebate {
    return TAX_REBATES_2023_24;
  }
  
  getTaxThresholds(): TaxThresholds {
    return TAX_THRESHOLDS_2023_24;
  }
  
  getMedicalAidCredits(): { mainMember: number; firstDependent: number; additionalDependent: number; } {
    return {
      mainMember: ANNUAL_MEDICAL_AID_CREDITS_2023_24.mainMember,
      firstDependent: ANNUAL_MEDICAL_AID_CREDITS_2023_24.firstDependent,
      additionalDependent: ANNUAL_MEDICAL_AID_CREDITS_2023_24.additionalDependent
    };
  }
  
  getStartDate(): Date {
    return new Date('2023-03-01');
  }
  
  getEndDate(): Date {
    return new Date('2024-02-29');
  }
}